import { gql } from '@apollo/client';
import { userProfileAttributes } from '../../auth/constants';

export const publicHolisticProjectAttributes = gql`
  {
    _id
    regionCode
    region
    projectName
    typeOfProject
    desc
    stage
    region
    primaryThumbnailUrl
    primaryPhoto {
      _id
      url
      images {
        s3Key
        size
        filename
        contentType
        url
        height
        width
        sizeCode
      }
    }
    numSupported
    fundingTarget
    fundingBalance
    fundingPercent
    createdAt
    updatedAt
    deletedAt
  }
`;

export const publicHolisticProjectDetailedAttributes = gql`
  {
    _id
    regionCode
    region
    projectName
    typeOfProject
    desc
    stage
    region
    primaryPhoto {
      _id
      url
      images {
        s3Key
        size
        filename
        contentType
        url
        height
        width
        sizeCode
      }
    }
    primaryBanner {
      _id
      url
      images {
        s3Key
        size
        filename
        contentType
        url
        height
        width
        sizeCode
      }
    }
    peopleGroupIds
    peopleGroups {
      _id
      nameAcrossCountries
      primaryThumbnailUrl
    }
    primaryThumbnailUrl
    numSupported
    fundingTarget
    fundingBalance
    fundingPercent
    createdAt
    updatedAt
    deletedAt
  }
`;

export const selectAProjectToSponsorQuery = gql`
  query SelectAProjectToSponsor(
    $first: Int
    $after: String
    $filters: HolisticProjectFiltersForPublic
    $sortBy: [SortBy]
  ) {
    allHolisticProjectsForPublic(first: $first, after: $after, filters: $filters, sortBy: $sortBy) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node ${publicHolisticProjectAttributes}
      }
    }
  }
`;

export const extractPublicHolisticProjects = (data) =>
  data && data.allHolisticProjectsForPublic;

export const publicHolisticProjectQuery = gql`
  query PublicHolisticProject($_id: ID!) {
    holisticProjectForPublic(_id: $_id) ${publicHolisticProjectDetailedAttributes}
  }
`;

export const extractPublicHolisticProject = (data) =>
  data && data.holisticProjectForPublic;

export const completeOnlineProjectSponsorshipMutation = gql`
  mutation CompleteOnlineProjectSponsorship($paymentId: ID!) {
    completeOnlineProjectSponsorship(paymentId: $paymentId) {
      projectSponsorship {
        _id
        contactId
        sponsorName
        projectId
        projectName
        regionCode
        region
        amount
        recurring
        startDate
        createdAt
        updatedAt
        deletedAt
      }
      profile ${userProfileAttributes}
      project ${publicHolisticProjectDetailedAttributes}
      payment {
        _id
        transactionId
        settlementId
        estimatedDepositDate
        recurringPaymentToken
        status
        usdCentsAmount
        paymentMethodType
        refundForId
        refundedById
        payerId
        payerName
        payerEmail
        fundId
        fundName
        ppCreatedOn
        ppUpdatedOn
        givenOn
        ppReceivedOn
        createdAt
        updatedAt
        deletedAt
      }
      recurringPayment {
        _id
        payerId
        payerName
        payerEmail
        amount
        status
        usdCentsAmount
        fundId
        fundName
        startDate
        frequency
        createdAt
        updatedAt
        deletedAt
      }
      userInvite {
        _id
      }
    }
  }
`;
